import { autoinject } from "aurelia-framework";

@autoinject()
export class ResumedFromMobileDialog {

    constructor() { }

    close() {
        location.reload();
    }
}
